import { useState, useEffect } from 'react';
import { SubscriptionService, PlanLimits } from '../services/subscriptionService';

export const useSubscriptionLimits = () => {
  const [currentPlan, setCurrentPlan] = useState<string>('free');
  const [planLimits, setPlanLimits] = useState<PlanLimits | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadPlanInfo = async () => {
      try {
        const plan = await SubscriptionService.getCurrentPlan();
        const limits = await SubscriptionService.getCurrentPlanLimits();
        
        setCurrentPlan(plan);
        setPlanLimits(limits);
      } catch (error) {
        console.error('Failed to load plan info:', error);
        // Fallback to free plan
        setCurrentPlan('free');
        setPlanLimits(await SubscriptionService.getCurrentPlanLimits());
      } finally {
        setLoading(false);
      }
    };

    loadPlanInfo();
  }, []);

  const checkLimit = async (
    type: 'rooms' | 'participants' | 'broadcastLinks' | 'apiKeys',
    currentCount: number
  ): Promise<{ allowed: boolean; reason?: string }> => {
    switch (type) {
      case 'rooms':
        return SubscriptionService.canCreateRoom(currentCount);
      case 'participants':
        return SubscriptionService.canAddParticipant(currentCount);
      case 'broadcastLinks':
        return SubscriptionService.canCreateBroadcastLink(currentCount);
      case 'apiKeys':
        return SubscriptionService.canCreateApiKey(currentCount);
      default:
        return { allowed: true };
    }
  };

  const checkFeatureAccess = async (feature: keyof PlanLimits): Promise<{ allowed: boolean; reason?: string }> => {
    return SubscriptionService.canAccessFeature(feature);
  };

  return {
    currentPlan,
    planLimits,
    loading,
    checkLimit,
    checkFeatureAccess
  };
};